import styled from 'styled-components';

import { Breakpoint, Color, FontWeight } from '../../../../enums';
import { StyledComponent } from '../../../../interfaces';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;

  @media ${Breakpoint.SmallMobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SocialIcon: StyledComponent<'img'> = styled.img``;

export const SocialButton: StyledComponent<'a'> = styled.a`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
  white-space: nowrap;
  display: flex;
  align-items: center;

  &:hover {
    color: ${Color.Gray500};
  }

  & + & {
    margin-left: 40px;

    @media ${Breakpoint.SmallMobile} {
      margin-left: 0;
      margin-top: 20px;
    }
  }
`;

export const SocialLabel: StyledComponent<'span'> = styled.span`
  margin-left: 8px;
`;
